export default __webpack_public_path__ + "static/media/DP.4df1ea59.jpg";